export function log(argument: string) {
  if (process.env.NODE_ENV === 'development' && process.env.logLevels === 'info') {
    /* eslint-disable no-console */
    console.log(argument);
  }
}
